import { InjectionToken } from '@angular/core';

import { TranslationConfig } from './translation-config.type';

export const TRANSLATION_CONFIGS = new InjectionToken<TranslationConfig[]>('Translations');
